var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000000865(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#4AC8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.499 16.805a17.732 17.732 0 0 0-12.51 5.184 17.69 17.69 0 0 0-5.19 12.494 17.487 17.487 0 0 0 3.566 10.607s.482.635.561.727L40.5 61.805l13.579-15.996a69.5 69.5 0 0 0 .555-.719l.002-.004a17.48 17.48 0 0 0 3.564-10.603 17.689 17.689 0 0 0-5.19-12.494 17.732 17.732 0 0 0-12.51-5.184zm0 24.107a6.441 6.441 0 0 1-5.947-3.969 6.422 6.422 0 0 1 1.396-7.005 6.44 6.44 0 0 1 10.987 4.545 6.432 6.432 0 0 1-1.887 4.544 6.448 6.448 0 0 1-4.55 1.885z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000000865);
export default __webpack_public_path__ + "static/media/Group 1000000865.a7843df1f6a5c54307b010b745ca8f5a.svg";
export { ForwardRef as ReactComponent };